/**
 * Guia de tamanhos nativo (painel "Guia de tamanhos" da página de produto).
 * Dados: metaobjeto dopa_guia_tamanhos (campos medidas e altura_peso, tabelas com colunas separadas por |),
 * ligado ao produto pelo metacampo dopa.guia_tamanhos. Markup em snippets/dopa-guia-tamanhos.liquid.
 *
 * A parte de cálculo (DopaGuia.parse*, DopaGuia.sizeFor) é pura e tem teste em tests/dopa-guia-tamanhos.test.js.
 */
(function (root) {
  'use strict';

  function parseNumber(v) {
    if (v === null || v === undefined) return NaN;
    var s = String(v).trim().replace(/\s/g, '').replace(',', '.');
    if (s === '' || !/^\d*\.?\d+$/.test(s)) return NaN;
    return parseFloat(s);
  }

  // "155-160" (ou com travessão) -> [155, 160]
  function parseRange(s) {
    var t = String(s || '').replace(/\s/g, '').replace(/[–—]/g, '-');
    var m = t.match(/^(\d+(?:[.,]\d+)?)-(\d+(?:[.,]\d+)?)$/);
    if (!m) return null;
    var lo = parseNumber(m[1]);
    var hi = parseNumber(m[2]);
    if (!(hi > lo)) return null;
    return [lo, hi];
  }

  // Texto do metaobjeto -> { w: [[lo,hi]...], h: [[lo,hi]...], cells: [['P','',...]...] }
  function parseChart(text) {
    var lines = String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length < 2) return null;
    var head = lines[0].split('|').map(function (c) { return c.trim(); });
    var w = head.slice(1).map(parseRange);
    if (!w.length || w.some(function (r) { return !r; })) return null;
    var h = [];
    var cells = [];
    for (var i = 1; i < lines.length; i++) {
      var parts = lines[i].split('|').map(function (c) { return c.trim(); });
      var r = parseRange(parts[0]);
      if (!r) return null;
      h.push(r);
      var row = [];
      for (var j = 0; j < w.length; j++) {
        var v = parts[j + 1] || '';
        row.push(v === '-' ? '' : v);
      }
      cells.push(row);
    }
    return { w: w, h: h, cells: cells };
  }

  // Altura em metros (1,75) vira centímetros.
  function normalizeHeight(v) {
    if (v > 0 && v < 3) return Math.round(v * 100);
    return v;
  }

  function band(ranges, v) {
    for (var i = 0; i < ranges.length; i++) {
      var lo = ranges[i][0];
      var hi = ranges[i][1];
      var last = i === ranges.length - 1;
      if (v >= lo && (v < hi || (last && v === hi))) return i;
    }
    return -1;
  }

  /**
   * Tamanho indicado pela tabela de altura e peso.
   * status: 'incompleto' (falta altura ou peso), 'fora' (fora das faixas da tabela),
   * 'sem' (a tabela não indica tamanho para a combinação), 'ok'.
   */
  function sizeFor(chart, alturaRaw, pesoRaw) {
    var altura = normalizeHeight(parseNumber(alturaRaw));
    var peso = parseNumber(pesoRaw);
    if (!chart) return { status: 'sem' };
    if (!(altura > 0) || !(peso > 0)) return { status: 'incompleto' };
    var row = band(chart.h, altura);
    var col = band(chart.w, peso);
    if (row < 0 || col < 0) {
      return {
        status: 'fora',
        altura: altura,
        peso: peso,
        alturaFora: row < 0,
        pesoFora: col < 0,
        hMin: chart.h[0][0],
        hMax: chart.h[chart.h.length - 1][1],
        wMin: chart.w[0][0],
        wMax: chart.w[chart.w.length - 1][1]
      };
    }
    var size = chart.cells[row][col];
    if (!size) return { status: 'sem', altura: altura, peso: peso, row: row, col: col };
    return { status: 'ok', size: size, row: row, col: col, altura: altura, peso: peso, h: chart.h[row], w: chart.w[col] };
  }

  function fmt(n) {
    return String(n).replace('.', ',');
  }

  var api = { parseNumber: parseNumber, parseRange: parseRange, parseChart: parseChart, sizeFor: sizeFor, band: band, normalizeHeight: normalizeHeight, fmt: fmt };
  root.DopaGuia = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (typeof document === 'undefined') return;

  // ---------- Tela ----------
  function init(el) {
    if (el.__dopaGuia) return;
    el.__dopaGuia = true;

    var sectionId = el.getAttribute('data-section');
    var optionName = el.getAttribute('data-option') || 'Tamanho';
    var sold = (el.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    var chartEl = el.querySelector('[data-chart]');
    var chart = chartEl ? parseChart(chartEl.textContent) : null;
    var panel = el.closest('.side-panel');

    var hIn = el.querySelector('[data-in="altura"]');
    var wIn = el.querySelector('[data-in="peso"]');
    var res = el.querySelector('[data-res]');
    var resSize = el.querySelector('[data-res-size]');
    var resSrc = el.querySelector('[data-res-src]');
    var resBtn = el.querySelector('[data-res-btn]');
    var hint = resSrc ? resSrc.textContent : '';

    var medHead = Array.prototype.slice.call(el.querySelectorAll('[data-med] thead th[data-size]'));
    var cells = Array.prototype.slice.call(el.querySelectorAll('[data-grid] td[data-r]'));

    var indicated = null;

    function selectedSize() {
      var scope = document.getElementById('ProductInfo-' + sectionId) || document;
      var checked = scope.querySelector('input[type="radio"][name="' + optionName + '"]:checked');
      if (checked) return checked.value;
      var sel = scope.querySelector('select[name="options[' + optionName + ']"]');
      return sel ? sel.value : null;
    }

    function markColumn(size) {
      var idx = -1;
      medHead.forEach(function (th) {
        if (th.getAttribute('data-size') === size) idx = th.getAttribute('data-col');
      });
      el.querySelectorAll('[data-med] [data-col]').forEach(function (c) {
        c.classList.toggle('is-on', String(c.getAttribute('data-col')) === String(idx));
      });
    }

    function markCell(row, col) {
      cells.forEach(function (td) {
        td.classList.toggle('is-on', +td.getAttribute('data-r') === row && +td.getAttribute('data-c') === col);
      });
    }

    function render(size, text, alert, canSelect) {
      resSize.textContent = size || '–';
      resSize.classList.toggle('is-empty', !size);
      resSrc.textContent = text;
      resSrc.classList.toggle('is-alert', !!alert);
      resBtn.disabled = !canSelect;
      resBtn.textContent = canSelect ? 'Selecionar ' + size : 'Selecionar tamanho';
    }

    function update() {
      if (!chart || !res) return;
      var r = sizeFor(chart, hIn.value, wIn.value);
      indicated = null;
      if (r.status === 'ok') {
        var vende = !sold.length || sold.indexOf(r.size) > -1;
        if (vende) indicated = r.size;
        var origem = 'Altura ' + fmt(r.h[0]) + '–' + fmt(r.h[1]) + ' cm e peso ' + fmt(r.w[0]) + '–' + fmt(r.w[1]) + ' kg na tabela abaixo.';
        if (!vende) origem += ' Este modelo não tem ' + r.size + ' à venda. Fale com a gente pelo chat para indicar a melhor opção.';
        render(r.size, origem, !vende, vende);
        markCell(r.row, r.col);
        markColumn(r.size);
        return;
      }
      markCell(-1, -1);
      markColumn(selectedSize());
      if (r.status === 'incompleto') {
        render(null, hint, false, false);
      } else if (r.status === 'fora') {
        var partes = [];
        if (r.alturaFora) partes.push('altura de ' + fmt(r.hMin) + ' a ' + fmt(r.hMax) + ' cm');
        if (r.pesoFora) partes.push('peso de ' + fmt(r.wMin) + ' a ' + fmt(r.wMax) + ' kg');
        render(null, 'A tabela vai de ' + partes.join(' e ') + '. Fale com a gente pelo chat para indicar o seu tamanho.', true, false);
      } else {
        render(null, 'A tabela não indica tamanho para essa combinação. Fale com a gente pelo chat para indicar o seu tamanho.', true, false);
      }
    }

    // Grade de altura e peso: ao passar o mouse, destaca a célula, a linha e a coluna dela.
    var grid = el.querySelector('[data-grid]');
    if (grid) {
      var headCells = Array.prototype.slice.call(grid.querySelectorAll('thead th'));
      var clearHover = function () {
        grid.classList.remove('is-hovering');
        grid.querySelectorAll('.is-hover, .is-axis').forEach(function (n) { n.classList.remove('is-hover', 'is-axis'); });
      };
      grid.addEventListener('mouseover', function (e) {
        var td = e.target.closest && e.target.closest('td[data-r]');
        if (!td || td.classList.contains('is-empty')) { clearHover(); return; }
        if (td.classList.contains('is-hover')) return;
        clearHover();
        var r = td.getAttribute('data-r');
        var c = td.getAttribute('data-c');
        grid.classList.add('is-hovering');
        td.classList.add('is-hover');
        cells.forEach(function (x) {
          if (x !== td && !x.classList.contains('is-empty') && (x.getAttribute('data-r') === r || x.getAttribute('data-c') === c)) x.classList.add('is-axis');
        });
        var rowHead = td.parentElement && td.parentElement.firstElementChild;
        if (rowHead) rowHead.classList.add('is-axis');
        var colHead = headCells[+c + 1];
        if (colHead) colHead.classList.add('is-axis');
      });
      grid.addEventListener('mouseleave', clearHover);
    }

    if (hIn && wIn) {
      hIn.addEventListener('input', update);
      wIn.addEventListener('input', update);
    }

    if (resBtn) {
      resBtn.addEventListener('click', function () {
        if (!indicated) return;
        var scope = document.getElementById('ProductInfo-' + sectionId) || document;
        var radio = scope.querySelector('input[type="radio"][name="' + optionName + '"][value="' + indicated.replace(/"/g, '\\"') + '"]');
        if (radio) {
          if (!radio.checked) radio.click();
        } else {
          var sel = scope.querySelector('select[name="options[' + optionName + ']"]');
          if (sel) {
            sel.value = indicated;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        var closer = panel && panel.querySelector('side-panel-close');
        if (closer) closer.click();
      });
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === optionName && !indicated) markColumn(selectedSize());
    });

    markColumn(selectedSize());
  }

  function boot() {
    document.querySelectorAll('[data-dopa-guia]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})(typeof window !== 'undefined' ? window : globalThis);
